import sendEvent from './send';

if (typeof window !== 'undefined') {
	document.addEventListener('DOMContentLoaded', function(){
		document.getElementsByClassName('quick-contacts__caption_phone')[0].addEventListener('click', () => {
			sendEvent(null, 'Top contacts', 'click', 'Phone');
		});

		document.getElementsByClassName('quick-contacts__caption_email')[0].addEventListener('click', () => {
			sendEvent(null, 'Top contacts', 'click', 'Email');
		});

		const ctaBtn = document.getElementsByClassName('cta-block__button')[0];

		if (ctaBtn) {
			ctaBtn.addEventListener('click', () => {
				sendEvent(ctaBtn.href, 'CTA', 'click', 'Contact us');
			});
		}

		const footerLinks = document.querySelectorAll('.footer__link');

		[].forEach.call(footerLinks, link => {
			link.addEventListener('click', () => {
				sendEvent(link.href, 'Footer links', 'click', link.href);
			});
		});

		const heroLinks = document.querySelectorAll('.hero__link');

		[].forEach.call(heroLinks, link => {
			link.addEventListener('click', () => {
				sendEvent(link.href, 'Hero links', 'click', link.href);
			});
		});
	});
}



// WEBPACK FOOTER //
// ./src/components/analytics/index.jsx